import { RadioItem } from "@atoms/index"

import { RadioCardProps } from "./RadioCard.types"

export default function RadioCard(props: RadioCardProps) {
    return <RadioItem {...props} variant="card" />
}
